import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';

import { includesConditionOptions } from 'constants/automation';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import { useFirmUserList } from 'hooks/useFirmUserList';
import { formatUserDropdown } from 'modules/automation/utils/formatUserDropdown';
import { AssignToItemTemplate } from 'modules/automation/WorkflowBuilder/components';

const EventGuestFilter = ({ index }) => {
  const { userList, isFirmUserLoading } = useFirmUserList(false, false, true);
  const {
    formState: { errors },
    control,
  } = useFormContext();

  return (
    <>
      <div className="me-2 filterbar-condition">
        <Controller
          name={`filters.${index}.condition`}
          control={control}
          rules={{ required: 'Condition is required' }}
          render={({ field }) => (
            <Dropdown
              value={field.value}
              name={field.name}
              options={includesConditionOptions}
              onChange={(e) => field.onChange(e.value)}
              filter
              className="w-100"
              placeholder="Select"
              inputRef={field.ref}
            />
          )}
        />
        <RequiredValidation field={`filters.${index}.condition`} errors={errors} />
      </div>
      <div className="me-2 filterbar-value">
        <Controller
          name={`filters.${index}.value`}
          control={control}
          rules={{ required: 'Value is required' }}
          render={({ field }) => (
            <MultiSelect
              value={field.value?.accessible_list || []}
              name={field.name}
              options={
                formatUserDropdown({
                  users: userList,
                  hideInactive: true,
                  includeContacts: false,
                  includesUserGroups: false,
                  includePrimarySecondary: true,
                  includeSelectedInactiveUser: true,
                  selectedItems: field.value?.accessible_list ? [field.value?.accessible_list] : [],
                }) || []
              }
              onChange={(e) => {
                field.onChange({ accessible_list: e.value });
              }}
              filter
              className="w-100 input-shadow "
              placeholder="Select"
              display="chip"
              optionLabel="label"
              optionGroupLabel="groupLabel"
              optionGroupChildren="items"
              itemTemplate={AssignToItemTemplate}
              dropdownIcon={isFirmUserLoading ? 'pi pi-spin pi-spinner' : undefined}
              inputRef={field.ref}
            />
          )}
        />
        <RequiredValidation field={`filters.${index}.value`} errors={errors} />
      </div>
    </>
  );
};

export default EventGuestFilter;
